import { useEffect } from "react";
import { Link } from "react-router-dom";
import { dataOverload } from "../../data/dataOverload";
import Styles from "./OverloadPage.module.css";

export const OverloadPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className={Styles["catalog"]}>
        <h2 className={Styles["title__catalog"]}>перегружатели</h2>
        <div className={Styles["items__catalog"]}>
          {dataOverload.map((item) => (
            <Link
              to={`/overloads/${item.title}`}
              className={Styles["item__catalog"]}
              key={item.id}
            >
              <img src={item.image} alt={item.title} />
              <h4 className={Styles["title__item"]}>{item.title}</h4>
              <div className={Styles["ttx__item"]}>
                <div className={Styles["weight__ttx"]}>
                  <p>Эксплутационная масса: </p>
                  <p>{item.operatingWeight} т</p>
                </div>
                <div className={Styles["load__ttx"]}>
                  <p>Производительность: </p>
                  <p>{item.layCapTheory} т/ч</p>
                </div>
              </div>
              <Link
                to={`/overloads/${item.title}`}
                className={Styles["item__btn"]}
              >
                подробнее
              </Link>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
};
